module.exports = __webpack_public_path__ + "img/baharain-img.d179bba6.png";